export default {
  HORSE_RACING: 200,
  GREYHOUNDS: 433200,
};
